export enum FeedbackStatus {
    SAVED = 'AUTO_SAVE',
    SUBMITTED = 'SUBMITTED'
}

export enum FeedbackType {
    OPTIONAL = 'OPTIONAL',
    REQUIRED = 'REQUIRED',
    CONSOLIDATED = 'CONSOLIDATED'
}

export enum FeedbackGroup {
    LEAD = 'LEAD',
    SUPER_LEAD = 'SUPER_LEAD',
    OTHER = 'OTHER'
}

export type Reason = {
    active: boolean;
    coefficient: number;
    markCriteriaId: number;
    name: string;
    reasonMessage: string;
};

export type FeedbackDto = {
    authorId: number;
    feedbackId: number | null;
    feedbackStatus: FeedbackStatus;
    feedbackType: FeedbackType;
    message: string;
    periodId: number;
    projectId: number;
    recipientId: number;
    reasons: Reason[];
    rating?: number;
};
